import React, { useState } from "react";
import "./members.css";
import Vendorlogs from "../Components/vendor_logs";
import { IoPersonCircle } from "react-icons/io5";
import { MdPersonAddAlt1 } from "react-icons/md";

function Members({ vendor }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div>
      <h1 className="dashboard-heading">Workers</h1>
      <button className="open-modal-btn" onClick={toggleModal}>
        <MdPersonAddAlt1 /> <span>Add New Members</span>
      </button>
      {isOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Add New Member</h2>
            <form
              className="member-form"
              onSubmit={(e) => {
                e.preventDefault();
                alert("Form submitted!");
              }}
            >
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="Email" required />
              <input type="tel" pattern="[0-9]{10}" placeholder="Phone Number" required />
              <input type="password" placeholder="Password" required />
              <input type="password" placeholder="Confirm Password" required />
              <textarea type="text" placeholder="13th floor Mahatma Gandhi Road, Ashok Nagaar, Bengaluru, karnataka (Office Address)" readOnly />

              <label className="select-label">Access Pages</label>
              <select multiple required>
                <option value="dashboard">Dashboard</option>
                <option value="settings">Settings</option>
                <option value="users">Users</option>
                <option value="reports">Reports</option>
                <option value="billing">Billing</option>
              </select>

              <button type="submit" className="glow-on-hover">
                Add Member
              </button>
            </form>

            <span className="close-btn" onClick={toggleModal}>
              ×
            </span>
          </div>
        </div>
      )}
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-photo-wrapper">
            {vendor?.profile ? (
              <img
                className="profile-photo"
                src={`${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${vendor.profile}`}
                alt="avatar"
              />
            ) : (
              <IoPersonCircle
                className="profile-photo"
                style={{ color: "#4b53c180" }}
              />
            )}
          </div>

          <div className="profile-info">
            <h2 className="profile-name">{vendor?.vendor_name || ""}</h2>
            <div className="profile-social1">
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Email:</strong> {vendor?.email || ""}
              </p>

              <p className="ss" style={{ margin: "3px" }}>
                <strong>Phone:</strong> {vendor?.phone_no || ""}
              </p>

              {/* {location.pathname !== "/profile" && ( */}
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Office Location:</strong> {vendor?.address || ""}
              </p>
              {/* )} */}
            </div>
          </div>
        </div>
        <div className="login-activity">
          <Vendorlogs />{" "}
        </div>
      </div>
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-photo-wrapper">
            {vendor?.profile ? (
              <img
                className="profile-photo"
                src={`${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${vendor.profile}`}
                alt="avatar"
              />
            ) : (
              <IoPersonCircle
                className="profile-photo"
                style={{ color: "#4b53c180" }}
              />
            )}
          </div>

          <div className="profile-info">
            <h2 className="profile-name">{vendor?.vendor_name || ""}</h2>
            <div className="profile-social1">
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Email:</strong> {vendor?.email || ""}
              </p>

              <p className="ss" style={{ margin: "3px" }}>
                <strong>Phone:</strong> {vendor?.phone_no || ""}
              </p>

              {/* {location.pathname !== "/profile" && ( */}
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Office Location:</strong> {vendor?.address || ""}
              </p>
              {/* )} */}
            </div>
          </div>
        </div>
        <div className="login-activity">
          <Vendorlogs />{" "}
        </div>
      </div>
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-photo-wrapper">
            {vendor?.profile ? (
              <img
                className="profile-photo"
                src={`${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${vendor.profile}`}
                alt="avatar"
              />
            ) : (
              <IoPersonCircle
                className="profile-photo"
                style={{ color: "#4b53c180" }}
              />
            )}
          </div>

          <div className="profile-info">
            <h2 className="profile-name">{vendor?.vendor_name || ""}</h2>
            <div className="profile-social1">
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Email:</strong> {vendor?.email || ""}
              </p>

              <p className="ss" style={{ margin: "3px" }}>
                <strong>Phone:</strong> {vendor?.phone_no || ""}
              </p>

              {/* {location.pathname !== "/profile" && ( */}
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Office Location:</strong> {vendor?.address || ""}
              </p>
              {/* )} */}
            </div>
          </div>
        </div>
        <div className="login-activity">
          <Vendorlogs />{" "}
        </div>
      </div>
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-photo-wrapper">
            {vendor?.profile ? (
              <img
                className="profile-photo"
                src={`${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${vendor.profile}`}
                alt="avatar"
              />
            ) : (
              <IoPersonCircle
                className="profile-photo"
                style={{ color: "#4b53c180" }}
              />
            )}
          </div>

          <div className="profile-info">
            <h2 className="profile-name">{vendor?.vendor_name || ""}</h2>
            <div className="profile-social1">
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Email:</strong> {vendor?.email || ""}
              </p>

              <p className="ss" style={{ margin: "3px" }}>
                <strong>Phone:</strong> {vendor?.phone_no || ""}
              </p>

              {/* {location.pathname !== "/profile" && ( */}
              <p className="ss" style={{ margin: "3px" }}>
                <strong>Office Location:</strong> {vendor?.address || ""}
              </p>
              {/* )} */}
            </div>
          </div>
        </div>
        <div className="login-activity">
          <Vendorlogs />{" "}
        </div>
      </div>
    </div>
  );
}

export default Members;